import { assoc, dissoc } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {};

const dialogReducer = {
	[types.OPEN]: (state, { payload: { name, title, type } }) => assoc(name, { title, type }, state),

	[types.CLOSE]: (state, action) => dissoc(action.payload.name, state),

	[types.CLEAR]: () => initialState,
};

export default handleActions(dialogReducer, initialState);
